import React, { useState, useContext } from 'react';
import Context from "../context/context";
import classnames from 'classnames';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {format_date_datepicker} from '../helpers/dates'
const Dates = props => {
  const {dateQuickLink, setDateQuickLink, endDateFormatted, setEndDateFormatted, startDateFormatted, setStartDateFormatted, setCurrentPage, startDateOpen, setStartDateOpen, endDateOpen, setEndDateOpen, startDate, setStartDate, endDate, setEndDate, activeFilters, setActiveFilters, filterNav, setFilterNav, setNavStatus} = useContext(Context);
  const {data, active, multi, handleClose, clearAllFilters, widget} = props;

  const [endDateShowing, setEndDateShowing] = useState(false);

  const toggleEndDateShowing = () => {
    setEndDateShowing(!endDateShowing);
  }

  let body = document.body;
  let minDate = new Date();
  let festivalStart = new Date('May 3, 2025 00:00:00');
  if (body.classList.contains('festival')){
    if (festivalStart > minDate) {

      minDate = festivalStart;
    }
  }

  const clearTheseFilters = () => {
    const a = {...activeFilters};
    const activeFilter = a[data.name];
    activeFilter.value = [false, false];
    activeFilter.selectedTitles = [];
    setStartDate(false);
    setStartDateFormatted('Date');
    setEndDate(false);
    setEndDateFormatted('Date');
    setActiveFilters(a);
    setCurrentPage(1)
    setDateQuickLink(false);

  }

  const clearThisFilter = (type) => {
    const a = {...activeFilters};
    const activeFilter = a[data.name];
    if (type == "start"){
      activeFilter.value = [false, false];
      setStartDate(false);
      setStartDateFormatted('Date');
      setEndDate(false);
      setEndDateFormatted('Date');
    }
    if (type == "end"){
      activeFilter.value[1] = false;
      setEndDate(false);
      setEndDateFormatted('Date');
    }
    activeFilter.selectedTitles = [];

    setActiveFilters(a);
    setCurrentPage(1);
    setDateQuickLink(false);
  }

  const handleViewResults = () => {
    handleClose();
    let updatedFilterNav = [...filterNav];
    updatedFilterNav.map((nav, i) => {
      nav.open = false;
    })
    setFilterNav(updatedFilterNav)
    setNavStatus(false);
    const body = document.querySelector('body');
    body.classList.remove('filters-open');
  }


  const toggleStartDateOpen = () => {
    setStartDateOpen(!startDateOpen);
    setEndDateOpen(false);
  }

  const toggleEndDateOpen = () => {
    setEndDateOpen(!endDateOpen);
    setStartDateOpen(false)
  }
  const handleChange = (date, type) => {
    const filter = {...activeFilters[data.name]};

    if (type == "start"){

      filter.value[0] = new Date(date.setHours(0,0,0,0));

      setStartDate(date);
      setStartDateFormatted(format_date_datepicker(date));


      if (filter.value[1]){
        let start_timestamp = date.setHours(0,0,0,0),
            end_timestamp = filter.value[1].setHours(0,0,0,0);
        if (start_timestamp > end_timestamp){
          setEndDate(date);
          setEndDateFormatted(format_date_datepicker(date));

        }
      }
    }

    if (type == "end"){
      filter.value[1] = new Date(date.setHours(0,0,0,0));
      setEndDate(date);
      setEndDateFormatted(format_date_datepicker(date));
    }

    setActiveFilters({...activeFilters,
      [data.name]: filter
    });

    setCurrentPage(1);
    setStartDateOpen(false);
    setEndDateOpen(false);

    setDateQuickLink(false);


  }


  const handleDateQuicklink = (quicklink) => {
    const filter = {...activeFilters[data.name]};

    let startDate = new Date();
    let endDate = new Date();

    if (quicklink == "today"){
      filter.value[0] = new Date(startDate.setHours(0,0,0,0));
      filter.value[1] = new Date(endDate.setHours(0,0,0,0));
      setDateQuickLink("today");
    } else if (quicklink == "tomorrow"){
      setDateQuickLink("tomorrow");

      startDate.setDate(startDate.getDate() + 1);
      endDate.setDate(endDate.getDate() + 1);

      filter.value[0] = new Date(startDate.setHours(0,0,0,0));
      filter.value[1] = new Date(endDate.setHours(0,0,0,0));
    } else if (quicklink == "this_weekend"){
      setDateQuickLink("this_weekend");

      let dayOfWeek = startDate.getDay();
      startDate = new Date(startDate.getTime() + (6 - dayOfWeek + 7) % 7 * 24 * 60 * 60 * 1000);
      endDate = new Date(startDate.getTime() + 24 * 60 * 60 * 1000);


      filter.value[0] = new Date(startDate.setHours(0,0,0,0));
      filter.value[1] = new Date(endDate.setHours(0,0,0,0));
    }


    setActiveFilters({...activeFilters,
      [data.name]: filter
    });

    setStartDate(startDate);
    setEndDate(endDate);
    setEndDateShowing(true);
    setStartDateFormatted(format_date_datepicker(startDate));
    setEndDateFormatted(format_date_datepicker(endDate));

    setCurrentPage(1);




  }

  return (
    <>
      <div className={classnames('level-2', {
        active: widget.open,
        })} >
        <div
        className={classnames('level-2-bg', {
          active: (startDateOpen || endDateOpen) && widget.open,
          })}


        ></div>


        <button className="filter-button filter-back" onClick={() => handleClose()}>
          <svg xmlns="http://www.w3.org/2000/svg" width="9" height="15" viewBox="0 0 9 15" fill="none">
            <path d="M8 13.5L2 7.5L8 1.5" stroke="black" stroke-width="2"/>
          </svg>
           Back
        </button>


        <div className="date-quicklinks">
          <button
            className={classnames('button button-black', {
              active: dateQuickLink == "today",
            })}
            onClick={() => handleDateQuicklink("today")}>
            Today
          </button>
          <button
            className={classnames('button button-black', {
              active: dateQuickLink == "tomorrow",
            })}
            onClick={() => handleDateQuicklink("tomorrow")}>
            Tomorrow
          </button>
          <button
            className={classnames('button button-black', {
              active: dateQuickLink == "this_weekend",
            })}
            onClick={() => handleDateQuicklink("this_weekend")}>
            This weekend
          </button>
        </div>

        <div className="datepicker-button" >
          <span class="datepicker-button-title">Select a start date</span>
          <button class="datepicker-button-info" onClick={toggleStartDateOpen}>
           <span class="datepicker-button-info-field">{startDateFormatted}</span>
           <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
            <path d="M15.8333 3.83325H4.16667L2.5 3.83327V18.8333H4.16667H15.8333H17.5V3.83327L15.8333 3.83325Z" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
            <path d="M13.3334 2.16675V5.50008" stroke="black" stroke-width="1.5" stroke-linecap="square"/>
            <path d="M6.66663 2.16675V5.50008" stroke="black" stroke-width="1.5" stroke-linecap="square"/>
            <path d="M2.5 8.83325H17.5" stroke="black" stroke-width="1.5" stroke-linecap="square"/>
           </svg>
          </button>
        </div>





        <div className="datepicker-button" >
          <button onClick={toggleEndDateShowing} class="datepicker-button-title is-button">Select an end date</button>

          {endDateShowing &&
            <button class="datepicker-button-info" onClick={toggleEndDateOpen}>
             <span class="datepicker-button-info-field">{endDateFormatted}</span>
             <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
              <path d="M15.8333 3.83325H4.16667L2.5 3.83327V18.8333H4.16667H15.8333H17.5V3.83327L15.8333 3.83325Z" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
              <path d="M13.3334 2.16675V5.50008" stroke="black" stroke-width="1.5" stroke-linecap="square"/>
              <path d="M6.66663 2.16675V5.50008" stroke="black" stroke-width="1.5" stroke-linecap="square"/>
              <path d="M2.5 8.83325H17.5" stroke="black" stroke-width="1.5" stroke-linecap="square"/>
             </svg>
            </button>
          }


        </div>



        <div className="filter-bottom">
          <button className="button button-black" onClick={() => handleViewResults()}>
            View results
          </button>
          <button className="filter-button filter-clear clear-all-filters button button-white-border" onClick={clearTheseFilters}>
            Reset these filters
          </button>
        </div>

      </div>


        <div className={classnames('datepicker-container', {
          active: startDateOpen && widget.open,
        })}>
        <button className="filter-button filter-back" onClick={() => toggleStartDateOpen()}>
          <svg xmlns="http://www.w3.org/2000/svg" width="9" height="15" viewBox="0 0 9 15" fill="none">
            <path d="M8 13.5L2 7.5L8 1.5" stroke="black" stroke-width="2"/>
          </svg>
           Back to When
        </button>
          <DatePicker
            showIcon
            selected={startDate}
            minDate={minDate}
            onChange={(date) => handleChange(date, 'start')}
            inline
          />

          <div class="button-wrapper">
             <button class="button button-reset" onClick={() => clearThisFilter('start')}>Reset this date</button>
          </div>

        </div>
          <div className={classnames('datepicker-container', {
            active: endDateOpen && widget.open,
          })}>
          <button className="filter-button filter-back" onClick={() => toggleEndDateOpen()}>
            <svg xmlns="http://www.w3.org/2000/svg" width="9" height="15" viewBox="0 0 9 15" fill="none">
              <path d="M8 13.5L2 7.5L8 1.5" stroke="black" stroke-width="2"/>
            </svg>
             Back to When
          </button>

            <DatePicker
              showIcon
              selected={endDate}
              minDate={(startDate) ? startDate : minDate }
              onChange={(date) => handleChange(date, 'end')}
              inline
            />

            <div class="button-wrapper">
               <button class="button button-reset" onClick={() => clearThisFilter('end')}>Reset this date</button>
            </div>


          </div>
      </>
  )
}

export default Dates;
